import React from 'react';

import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useContainer } from 'unstated-next';

import InviteStudentsContainer from './InviteStudentsContainer';
import { StyledAlert } from './styles/styled-components';

const StyledContainer = styled.div`
    margin-left: 16px;
    margin-right: 16px;
    h1 {
        font-size: 1.25rem;
    }
`;

const ButtonContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    margin-top: 16px;
`;

const SubmitPartialSuccess: React.FunctionComponent = () => {
    const { t } = useTranslation('invite_students');
    const { alerts, setAlerts, returnToRosterUrl } = useContainer(InviteStudentsContainer);

    const handleOKClick = () => {
        // TODO - ought to be history.push but when in demo mode URL isn't a react path.
        window.location.href = returnToRosterUrl;
    };

    return <StyledContainer>
        <h1>
            { t('errors.invite-partial-success') }
        </h1>
        <>
            {
                alerts.map((alert, index) => {
                    const message = typeof alert.message === 'function' ? alert.message() : alert.message;
                    return <StyledAlert
                        sx={{ my: 4 }}
                        key={index}
                        variant="outlined"
                        severity={alert.severity}
                        onClose={() => {
                            setAlerts(alerts.filter((value, i) => i !== index));
                        }}
                    >
                        {message}
                    </StyledAlert>;
                })
            }
        </>
        <ButtonContainer>
            <Button variant="contained" onClick={handleOKClick}>{t('components.ok')}</Button>
        </ButtonContainer>
    </StyledContainer>;
};

export default SubmitPartialSuccess;
